export const siteSettings = {
  name: "Crypto Pips",
  link: "https://cryptopips.net",
  email: "support@cryptopips.net",
  appLink: "https://app.cryptopips.net",
};
